/**
 * @generated SignedSource<<39e0fd2b8ddf140933902a028eedc3ff>>
 * @relayHash bf6325c2edd11bd3321be86df9129cf8
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 3aafa734739fbf9b352677446fd07dae3aa7a5c110d707c67e99502394997b8c

import type { ConcreteRequest } from 'relay-runtime';
export type useInjectDraftContentConfluenceDraftQuery$variables = {
  contentId: string;
  status: ReadonlyArray<string | null>;
};
export type useInjectDraftContentConfluenceDraftQuery$data = {
  readonly content: {
    readonly nodes: ReadonlyArray<{
      readonly appearanceDraft: {
        readonly nodes: ReadonlyArray<{
          readonly id: string | null;
          readonly key: string | null;
          readonly value: string | null;
          readonly version: {
            readonly number: number | null;
          } | null;
        } | null> | null;
      } | null;
      readonly body: {
        readonly atlas_doc_format: {
          readonly value: string | null;
        } | null;
      } | null;
      readonly id: string | null;
      readonly status: string | null;
      readonly title: string | null;
      readonly type: string | null;
    } | null> | null;
  } | null;
};
export type useInjectDraftContentConfluenceDraftQuery = {
  response: useInjectDraftContentConfluenceDraftQuery$data;
  variables: useInjectDraftContentConfluenceDraftQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "contentId"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "status"
  }
],
v1 = {
  "kind": "ScalarField",
  "name": "id"
},
v2 = {
  "kind": "ScalarField",
  "name": "value"
},
v3 = [
  {
    "args": [
      {
        "kind": "Variable",
        "name": "id",
        "variableName": "contentId"
      },
      {
        "kind": "Variable",
        "name": "status",
        "variableName": "status"
      }
    ],
    "concreteType": "PaginatedContentListWithChild",
    "kind": "LinkedField",
    "name": "content",
    "plural": false,
    "selections": [
      {
        "concreteType": "Content",
        "kind": "LinkedField",
        "name": "nodes",
        "plural": true,
        "selections": [
          {
            "alias": "appearanceDraft",
            "args": [
              {
                "kind": "Literal",
                "name": "key",
                "value": "content-appearance-draft"
              }
            ],
            "concreteType": "PaginatedJsonContentPropertyList",
            "kind": "LinkedField",
            "name": "properties",
            "plural": false,
            "selections": [
              {
                "concreteType": "JsonContentProperty",
                "kind": "LinkedField",
                "name": "nodes",
                "plural": true,
                "selections": [
                  (v1/*: any*/),
                  {
                    "kind": "ScalarField",
                    "name": "key"
                  },
                  (v2/*: any*/),
                  {
                    "concreteType": "Version",
                    "kind": "LinkedField",
                    "name": "version",
                    "plural": false,
                    "selections": [
                      {
                        "kind": "ScalarField",
                        "name": "number"
                      }
                    ]
                  }
                ]
              }
            ],
            "storageKey": "properties(key:\"content-appearance-draft\")"
          },
          (v1/*: any*/),
          {
            "kind": "ScalarField",
            "name": "type"
          },
          {
            "kind": "ScalarField",
            "name": "status"
          },
          {
            "kind": "ScalarField",
            "name": "title"
          },
          {
            "concreteType": "ContentBodyPerRepresentation",
            "kind": "LinkedField",
            "name": "body",
            "plural": false,
            "selections": [
              {
                "concreteType": "ContentBody",
                "kind": "LinkedField",
                "name": "atlas_doc_format",
                "plural": false,
                "selections": [
                  (v2/*: any*/)
                ]
              }
            ]
          }
        ]
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "useInjectDraftContentConfluenceDraftQuery",
    "selections": (v3/*: any*/),
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "useInjectDraftContentConfluenceDraftQuery",
    "selections": (v3/*: any*/)
  },
  "params": {
    "cacheID": "bf6325c2edd11bd3321be86df9129cf8",
    "id": "3aafa734739fbf9b352677446fd07dae3aa7a5c110d707c67e99502394997b8c",
    "metadata": {},
    "name": "useInjectDraftContentConfluenceDraftQuery",
    "operationKind": "query",
    "text": "query useInjectDraftContentConfluenceDraftQuery($contentId:ID!,$status:[String]!){content(id:$contentId,status:$status){nodes{appearanceDraft:properties(key:\"content-appearance-draft\"){nodes{id,key,value,version{number}}},id,type,status,title,body{atlas_doc_format{value}}}}}"
  }
};
})();

(node as any).hash = "532dc301ea1496d62e464496efa31b13";

export default node;
